jQuery(function ($) {
  $(".quantity-button-wrapper .quantity select").on("change", function () {
    $(this)
      .closest(".quantity-button-wrapper")
      .find(".ajax_add_to_cart")
      .attr("data-quantity", $(this).val());
  });

  // Product-tag block quantity input handling
  $(document).on(
    "change",
    ".wp-block-woocommerce-product-tag .product-tag-qty",
    function () {
      const $quantityInput = $(this);
      const $button = $quantityInput
        .closest(".quantity-button-wrapper")
        .find(".ajax_add_to_cart");
      const quantity = $quantityInput.val();

      // Update the button's data-quantity attribute
      $button.attr("data-quantity", quantity);
    }
  );

  // Product-tag block specific add to cart handling
  $(document).on(
    "click",
    ".wp-block-woocommerce-product-tag .add_to_cart_button.product-tag-custom",
    function (e) {
      const $button = $(this);
      const $wrapper = $button.closest(".quantity-button-wrapper");
      const $quantityInput = $wrapper.find(".product-tag-qty");

      // Ensure quantity is set from input
      if ($quantityInput.length) {
        const quantity = $quantityInput.val() || 1;
        $button.attr("data-quantity", quantity);
      }

      // Add custom loading state
      $button.addClass("custom-loading");

      // Custom analytics or tracking for product-tag block
      if (typeof gtag !== "undefined") {
        gtag("event", "add_to_cart_product_tag", {
          event_category: "ecommerce",
          event_label: $button.data("product_sku") || "unknown",
          value: $button.data("quantity") || 1,
        });
      }

      // Remove custom loading after a delay
      setTimeout(() => {
        $button.removeClass("custom-loading");
      }, 3000);
    }
  );

  $(".tiered-pricing-block").each(function () {
    const $this = $(this);

    $this.addClass("loaded");

    const price = $this.data("tiered-price");
    const priceWithTransfer = price * 0.9;
    const priceWithTransferFormatted = new Intl.NumberFormat("es-AR").format(
      priceWithTransfer
    );

    const quantity = $this.data("tiered-quantity");

    if (quantity > 1) {
      $this
        .find(".woocommerce-Price-amount.amount")
        .append('<span class="tiered-pricing-block__price-unit">c/u</span>');
    }

    $this
      .find(".tiered-pricing-block__price")
      .after(
        `<div class="tiered-pricing-block__price-installments">3 cuotas sin interés</div><div class="tiered-pricing-block__price-transfer">$${priceWithTransferFormatted} <span class="tiered-pricing-block__price-transfer-text">Transf. bancaria</span></div>`
      );
  });
});
